module.exports = __webpack_public_path__ + "img/manage-account.a15fd15f.svg";